import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SeasonalOffers = () => {
  const [imageList, setImageList] = useState([]);
  const [viewAll, setViewAll] = useState(true);

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/SeasonalOffer_Images/get-SeasonalOffers-images')
      .then((res) => {
        const formatted = res.data.map((item, idx) => ({
          src: item.base64.startsWith('data:')
            ? item.base64
            : `data:image/png;base64,${item.base64}`,
          alt: `Seasonal Ad ${idx + 1}`,
          url: item.merchantURL,
        }));
        setImageList(formatted);
      })
      .catch((err) => console.error(err));
  }, []);

  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <Wrapper>
      <div className="heading">
        <p className="title">Seasonal Offers!</p>
        <p className="see-more" onClick={() => setViewAll(!viewAll)}>
          {viewAll ? 'View All' : 'View Less'}
        </p>
      </div>

      {viewAll ? (
        <SliderWrapper className="slider">
          <Slider {...settings}>
            {imageList.map((item, idx) => (
              <div key={idx}>
                <Card>
                  <a href={`https://${item.url}`} target="_blank" rel="noopener noreferrer">
                    <img src={item.src} alt={item.alt} />
                  </a>
                </Card>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      ) : (
        <ImageGrid>
          {imageList.map((item, idx) => (
            <Card key={idx}>
              <a href={`https://${item.url}`} target="_blank" rel="noopener noreferrer">
                <img src={item.src} alt={item.alt} />
              </a>
            </Card>
          ))}
        </ImageGrid>
      )}
    </Wrapper>
  );
};

export default SeasonalOffers;


const Wrapper = styled.section`
  background: #a4d3ff;  
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  border-radius:5px;
  wigth:90%;
  margin-bottom:20px;

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
  }

  .see-more {
    font-size: 16px;
    cursor: pointer;
    // text-decoration: underline;
    // color: #4a4a4bff;
  }
  .see-more:hover {
    text-decoration: underline;
    // color: #4a4a4bff;
  }

  @media(max-width:576px){
    width:50%;
  }
  @media(max-width:1000px){
    width:70%;
  }
  @media(max-width:1280px){
    width:90%;
  }
`;

const SliderWrapper = styled.div`
  .slick-slide {
    padding: 0 10px;
  }

  .slick-prev,
  .slick-next {
    width: 40px;
    height: 40px;
    z-index: 2;
  }

  .slick-prev:before,
  .slick-next:before {
    color: black;
    font-size: 24px;
  }

  @media(max-width:576px){
    .slick-slide {
      padding: 0 40px;
    }
  }
`;

const Card = styled.div`
  // background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  text-align: center;

  img {
    width: 100%;
    height: 200px;
    object-fit: fit;
  }

  .card-body {
    padding: 12px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
  }

  .card-text {
    font-size: 14px;
    color: #555;
    margin: 6px 0 12px;
  }

  .btn {
    display: inline-block;
    background: #007bff;
    color: #fff;
    padding: 6px 12px;
    font-size: 14px;
    text-decoration: none;
    border-radius: 4px;
  }

  .btn:hover {
    background: #0056b3;
  }
  @media(max-width:576px){
    img {
      height: auto;
    }
  }
  
`;

const ImageGrid = styled.div`
  display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;

   @media(max-width:576px){
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    height:auto;
    gap: 6px;
  }
`;
